const restRoot = `${process.env.PUBLIC_URL}/api/v1`;

/**
 * rest fetch which returns true or false if the REST call was successfull or not
 * @param {string} method method of the REST request
 * @param {string} query the query string for the REST request
 * @param {Object} payload payload of the REST request
 * @param {Object} options options request options
 * @returns {Promise} Promise with result as json.
 */
async function sendMutation(method, query, payload, options) {
  let response;
  try {
    let body;
    const headers = {
      Accept: 'application/json', // eslint-disable-line quote-props
    };
    if (payload instanceof FormData) {
      body = payload;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }
    let url;
    if (options && options.noPrefix) {
      url = query;
    } else {
      url = `${restRoot}${query}`;
    }
    const initData = {};
    if (options && options.credentials)
      initData.credentials = options.credentials;
    response = await fetch(url, {
      headers,
      method: method.toUpperCase(),
      body,
      ...initData,
    });
  } catch (e) {
    console.log(`${query} ${method} Fetch throwed: `, e); // eslint-disable-line no-console
    return {
      error: true,
      errorInfo: 'FETCH_THROWED',
      statusCode: null,
      body: e,
    };
  }

  let json;
  try {
    json = await response.json();
  } catch (e) {
    json = null;
  }

  const { status } = response;
  if (status === 200 || status === 202) {
    return {
      error: false,
      statusCode: status,
      body: json,
    };
  }

  // eslint-disable-next-line no-console
  console.log(`${query} ${method} Response received status code: ${status}`);
  return {
    error: true,
    errorInfo: 'WRONG_STATUS',
    statusCode: status,
    body: json,
  };
}

export default sendMutation;
